import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useContacts = ({ searchParam, pageNumber, date, dateStart, dateEnd }) => {
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [count, setCount] = useState(0);

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    const { data } = await api.get("/contacts", {
                        params: {
                            searchParam,
                            pageNumber,
                            date,
                            dateStart,
                            dateEnd,
                        },
                    });

                    if (!isMounted) return;

                    // Safe destructuring with fallback values
                    setContacts(Array.isArray(data?.contacts) ? data.contacts : []);
                    setHasMore(Boolean(data?.hasMore));
                    setCount(typeof data?.count === 'number' ? data.count : 0);
                    setLoading(false);
                } catch (err) {
                    if (isMounted) {
                        setLoading(false);
                        toastError(err);
                    }
                }
            };

            fetchContacts();
        }, 500);
        return () => {
            isMounted = false;
            clearTimeout(delayDebounceFn);
        };
    }, [searchParam, pageNumber, date, dateStart, dateEnd]);

    return { contacts, loading, hasMore, count };
};

export default useContacts;
